// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { getNestedByString } from 'helpers/reduxFormFunctions'
import initialContactLookupFormValues from 'components/SearchAndSelect/Sets/Contact/initialFormValues'
import { initialize, setSubmitSucceeded } from 'redux-form'

const getContactLookupInitialValues = (sourceForm, sourceField, lookupFormName) => (dispatch, getState) => {
  const initialValues = { ...initialContactLookupFormValues }

  let triggerSearchOnMount = false

  try {
    const { values } = getState().form[sourceForm]
    const serviceContactCode = getNestedByString(values, sourceField)

    if (serviceContactCode) {
      initialValues.serviceContactCode = getNestedByString(values, sourceField)
      triggerSearchOnMount = true
    }
  } catch (err) {
    console.warn()
  }

  // if we want the lookup to auto search on mount, we need set some things up in redux
  if (triggerSearchOnMount) {
    dispatch(initialize(lookupFormName, initialValues))
    dispatch(setSubmitSucceeded(lookupFormName))
  }

  return {
    initialValues,
    triggerSearchOnMount,
  }
}

export default getContactLookupInitialValues
